export default __webpack_public_path__ + "static/media/ancient-ruins.2366baf50a5726af508d74435b578168.jpg";